export const LEGAL_COOKIES_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Cookie-Nutzung</h1>
 Anpassen Ihrer Cookies
</center>

---
`;
